export default {
  SHOW_ALERT(state, payload) {
    if (!payload.message || payload.message === "") return false;
    state.isActive = true;
    state.alert = payload;
  },
  CLOSE_ALERT(state) {
    state.isActive = false;
    state.alert = {};
  },
};
